import { CART_ITEM_STATUS } from "constants/cart";
import { isFilingFiledExternally } from "./isFilingFiledExternally";

const SAVED_FOR_LATER_LABEL = "Saved for later";
const FILED_EXTERNALLY_LABEL = "Filed externally";

export type FilingStatusTag = {
  label: string;
  tagType: "yellow" | "blue";
};

export const getFilingStatusTag = (status?: string): FilingStatusTag | null => {
  if (status === CART_ITEM_STATUS.SAVED_FOR_LATER) {
    return { label: SAVED_FOR_LATER_LABEL, tagType: "yellow" };
  }

  if (isFilingFiledExternally(status)) {
    return { label: FILED_EXTERNALLY_LABEL, tagType: "blue" };
  }

  return null;
};
